<div (click)="toggleAnnounce($event,true)" class="position__relative">
    <!-- <div class="announce css-hide-desktop" *ngIf="showingAnnounce && product?.announce">
        <span>{{'DISRUPTION' | translate}} <br>{{product?.announce}}</span>
    </div> -->

    <div id="product-banner" class="product-banner">
        <ng-container *ngIf="product">
            <div class="collection" [class.animationMin]="animationMin" [class.animationMax]="animationMax" (mouseout)="mouseOvered=false" (mouseover)="mouseOvered=true">
                <div class="collection-box" *ngFor="let img of imagesHeader; let i = index; let idx = index" (swipeleft)="swipe(idx, $event.type)" (swiperight)="swipe(idx, $event.type)" [class.animation]="isAnimated">
                    <div class="collection-box-wrap" (click)="openGalleryB(img)">
                        <progressive-image [ngClass]="{'animationNext':animationNext, 'animationPrev':animationPrev}" imgClass="collection-box--image" [bigImage]="img" [smallImage]="imagesHeaderMicro[i]"></progressive-image>
                        <!--<img [ngClass]="{'animationNext':animationNext, 'animationPrev':animationPrev}" class="collection-box--image" [src]="img" /> -->
                    </div>
                </div>
                <!-- <div class="btn-share css-hide-phone css-hide-tablet">
                    <i class="material-icons notranslate">share</i>
                    <span>Share</span>
                </div> -->
                <div [class.btn-view-over]="mouseOvered" class="btn-view css-hide-phone css-hide-tablet" (click)="openGallery()">
                    <span>{{'VIEW_PHOTOS' | translate}}</span>
                </div>
                <div class="btn-next css-hide-desktop" (click)="nextImage()">
                    <i class="material-icons notranslate">keyboard_arrow_right</i>
                </div>
                <div class="btn-previous css-hide-desktop" (click)="previousImage()">
                    <i class="material-icons notranslate">keyboard_arrow_left</i>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="product && !notAvailable" class="product-general">
        <price-promotion *ngIf="product?.bestPriceInfo?.promotion?.promotionType === 'RETAIL'" [price]="product?.bestPriceInfo?.bestPrice" [promotion]="product?.bestPriceInfo?.promotion" [typeText]="true" (onChangePrices)="changePrice($event)" class="product-general__discount"></price-promotion>
        <div class="product-general__name">
            <h1>{{product?.name}}</h1>
        </div>
        <div class="product-general__price">
            <div class="price">
                <p class="price__from">{{'FROM' | translate }}</p>
                <p class="price__best notranslate">{{product?.bestPrice | currency:currencyService.currencyStr:true:'1.2-2'}}</p>
                <ng-container *ngIf="product?.bestPriceInfo?.promotion?.promotionType === 'RETAIL'">
                    <p class="price__old notranslate">{{highPrice | currency:currencyService.currencyStr:true:'1.2-2'}}</p>
                </ng-container>
            </div>
        </div>
    </div>
    <div sticky-view *ngIf="!isNode" class="product-menu css-hide-phone css-hide-tablet">
        <div class="mdl-cell--9-col product-menu__bar">
            <div class="product-menu__item" (click)="scrollToInfo('product-banner')"><a>{{'SUMMARY_' | translate | uppercase}}</a></div>
            <div class="product-menu__item" (click)="scrollToInfo('highlights')"><a>{{'HIGHLIGHTS' | translate | uppercase}}</a></div>
            <div class="product-menu__item" (click)="scrollToInfo('map')"><a>{{ 'MAP' | translate | uppercase}}</a></div>
            <div class="product-menu__item" (click)="scrollToInfo('included')"><a>{{'INCLUDED' | translate | uppercase}}</a></div>
            <div class="product-menu__item" (click)="scrollToInfo('information')"><a>{{'ADDITIONAL_INFORMATION' | translate | uppercase}}</a></div>
            <div class="product-menu__item" (click)="scrollToInfo('before')"><a>{{'KNOW_BEFORE_YOU_GO' | translate | uppercase}}</a></div>
        </div>
        <button *ngIf="showMenuButton" (click)="goToCalendar()" [ngClass]="{'product-menu__button': showMenuButton}" class="mdl-cell--3-col">
            <span>{{'CALENDAR' | translate}}</span>
            <i class="material-icons notranslate">event_note</i>
        </button>
    </div>
    <div class="product-error" *ngIf="notAvailable">
        <h1>{{ 'PRODUCT_AVAILABILITY' | translate}}</h1>
    </div>
    <div class="product-check-btn css-hide-desktop">
        <button (click)="goToCalendar()" color="primary" class="payment-button" mat-raised-button >{{'CHECK_AVAILABILITY' | translate}}</button>
    </div>
    <div class="css-content optionb mdl-grid product-info" id="availability-legend">
        <div class="mdl-cell--9-col mdl-cell--12-col-phone mdl-cell--12-col-tablet phone__full-width">
            <div class="product-announce" *ngIf="product?.announces && product?.announces.length">
                <i class="material-icons notranslate">warning</i>
                <div>
                    <p *ngFor="let announce of product?.announces">{{announce}}</p>
                </div>
            </div>
            <div class="product-info__text">
                <p>{{product?.description}}</p>
            </div>
            <product-legends [product]="product" *ngIf="!notAvailable"></product-legends>
        </div>
        <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-tablet mdl-cell--12-col-phone" id="price-box">
            <product-price class="product-price" id="product-price" [product]="product" (onBookClicked)="checkAvailability($event)" (onGetTotalHeight)="getHeightFromProductPrice($event)"></product-price>
        </div>
    </div>
    <div class="spinner">
        <loading-component #spinnerOptions></loading-component>
    </div>
    <product-options [hidden]="!options" [product]="product" [options]="options"></product-options>
    <product-details id="highlights" [product]="product"></product-details>
    <main-stops id="main-stops" [product]="product"></main-stops>
    <div id="map-point"></div>
    <!-- <product-additional text-color="gray-dark" [product]="product"></product-additional> -->
    <section class="mdl-cell--8-col mdl-cell--12-col-phone product-additional">
        <div id="included" class="product-additional__included">
            <h3 *ngIf="product?.included || product?.inclussions">{{'INCLUDED' | translate}}</h3>
            <div class="included product-additional__text" [innerHtml]="product?.included || ''" *ngIf="product?.included"></div>
            <div class="not-included product-additional__text" [innerHtml]="product?.notIncluded || ''" *ngIf="product?.notIncluded"></div>
            <div class="product-additional__text" *ngIf="product?.inclussions || product?.exclussions">
                <strong>{{product.name}}</strong>
                <div class="included" *ngIf="product?.inclussions">
                    <ul>
                        <li *ngFor="let inclussion of product.inclussions">
                            {{inclussion}}
                        </li>
                    </ul>
                </div>
                <div class="not-included" *ngIf="product?.exclussions">
                    <ul>
                        <li *ngFor="let exclussion of product.exclussions">
                            {{exclussion}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="information" class="product-additional__information">
            <h3>{{'ADDITIONAL_INFORMATION' | translate}}</h3>
            <div class="product-additional__text" [innerHtml]="product?.longDescription || ''"></div>
        </div>
        <div id="before" class="product-additional__know-before">
            <h3 *ngIf="product?.additionalInfo">{{'KNOW_BEFORE_YOU_GO' | translate}}</h3>
            <div class="product-additional__text" [innerHtml]="product?.additionalInfo || ''"></div>
        </div>
    </section>
    <product-route id="map" [mapOffset]="mapOffset" [product]="product"></product-route>
    <section class="mdl-cell--9-col mdl-cell--12-col-phone product-additional second-section">
        <div id="cancelation" class="product-additional__cancelation">
            <h3 *ngIf="product?.cancelPolitic">{{'CANCEL_POLICY' | translate}}</h3>
            <div class="product-additional__text" [innerHtml]="product?.cancelPolitic || ''"></div>
        </div>
        <div id="supplied" class="product-additional__supplied">
            <h3 *ngIf="product?.provider">{{'SUPPLIED_BY' | translate}}</h3>
            <div class="product-additional__text">
                <div [innerHtml]="product?.provider?.companyName || ''"></div>
                <div [innerHtml]="product?.provider?.address || ''"></div>
                <div>
                    <span *ngIf="product?.provider?.zip" [innerHtml]="(product?.provider?.zip)+ ', '"></span>
                    <span *ngIf="product?.provider?.location" [innerHtml]="(product?.provider?.location)+ ', '"></span>
                    <span *ngIf="product?.provider?.location" [innerHtml]="(product?.provider?.country) || ''"></span>
                </div>
            </div>
        </div>
        <button color="accent" mat-raised-button class="product-additional__button" *ngIf="product?.cruiseShipInfo" (click)="openCruiseShip()">{{'CRUISE_SHIP_INFO' | translate}}</button>
        <div *ngIf="isReady && cruiseIsOpened" class="modal" (click)="closeCruiseShip()">
                <mat-card (click)="onEvent($event)">
                    <mat-icon class="notranslate" (click)="closeCruiseShip()">close</mat-icon>
                    <mat-card-title>{{'CRUISE_SHIP_INFO' | translate}}</mat-card-title>
                    <mat-card-content>
                        <div [innerHtml]="product?.cruiseShipInfo || ''"></div>
                    </mat-card-content>
                </mat-card>
            </div>
    </section>

    <div *ngIf="showSeeOptions && deviceName === 'mobile'" id="onMobileView">
        <button (click)="scrollToInfo('product-price')" color="primary" class="payment-button" mat-raised-button><span>{{'SEE_OPTIONS' | translate}}</span></button>
    </div>
    <gallery [images]="images" [img]="img" [control] = "galleryIsHidden" (onClose)="closeGallery()"></gallery>
</div>